import { Component, input, output } from '@angular/core';
import { IceInfoIconComponent } from '@app/shared/components/atoms/ice-info-icon/ice-info-icon.component';

@Component({
  selector: 'app-information-button',
  imports: [IceInfoIconComponent],
  templateUrl: './information-button.component.html',
  styleUrl: './information-button.component.scss',
})
export class InformationButtonComponent {
  activeLabel = input.required<string>();
  inactiveLabel = input.required<string>();
  toggleInfo = output();
  isActive = false;

  toggleActive() {
    this.isActive = !this.isActive;
    this.toggleInfo.emit();
  }

  get label(): string {
    return this.isActive ? this.activeLabel() : this.inactiveLabel();
  }
}
